import { useEffect, useState } from 'react';

export function ClientOnly({ children, gate = true }: { children: React.ReactNode; gate?: boolean }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') setIsClient(true);
  }, []);

  if (!isClient) return null;

  return gate ? <>{children}</> : null;
}
